import React, { useState, useEffect, useRef } from 'react';
import '../styles/hero.css';
import '../styles/aboutSection.css';
import '../styles/chooseUsSection.css';
import '../styles/processSection.css';
import '../styles/testimonial.css';
import '../styles/bookingSection.css';

import heroImage from "../assets/img/hero/hero2.png" // Make sure to place image assets in `public` or `src/assets` and adjust the path accordingly
 
import testimonial from "../assets/img/testimonial/carman.png"
import testimonial1 from "../assets/img/testimonial/pk.jpeg"
import testimonial2 from "../assets/img/testimonial/DKahenya.jpeg"
import testimonial3 from "../assets/img/testimonial/tf.jpg"

import { Link, useLocation, useNavigate } from 'react-router-dom';
 import projectVideo from "../assets/Videos/Clip8.mp4"
 import Footer from '../components/Footer';
import { IoIosFlash } from "react-icons/io";
import { TfiWorld } from "react-icons/tfi";
import { FaFileInvoiceDollar } from "react-icons/fa";
import { RiVideoFill } from "react-icons/ri";
import { useMediaQuery } from 'react-responsive';
import Nav from '../components/Nav';
 import caseStudy1 from "../assets/img/caseStudies/dm5.png"
 import caseStudy2 from "../assets/img/caseStudies/f3.png"
 import caseStudy3 from "../assets/img/caseStudies/pr11.png"
 import caseStudy4 from "../assets/img/caseStudies/dm2.png"
 import caseStudy5 from "../assets/img/caseStudies/crm3.png"

 import WhatsAppWidget from '../components/WhatsappWidget';
import { trackVisitor } from '../features/track/trackSlice';
import { useDispatch } from "react-redux";
import { MdOutlineSupportAgent } from "react-icons/md";
import { MediaSidebarData } from '../components/MediaSidebarData';

const Home = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();
   const isDesktop = useMediaQuery({ minWidth: 768 });
   const caseStudyImg = isDesktop ? caseStudy1 : caseStudy4
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();


   useEffect(() => {
    const timeout = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

 
const handleContactBtn = () => {
  navigate("/get-in-touch")
}

const handleLearnMore = () => {
  navigate("/recent-work")
}

const handleWebsite = () => {
  window.location.href="/website"
}

const handleInvoice = () => {
  window.location.href="/invoice-generator"
}

const handleDigitalMarketing = () => {
  window.location.href="/digital-marketing"
}

const handleVideo = () => {
  window.location.href="https://lozano-films.onrender.com"
}



   const servicesRef = useRef(null);
      
   useEffect (() => {
    const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
     const scrollReveal = () => {
        for (let i = 0; i < revealElements.length; i++) {
         const elementIsInScreen =
        revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
      
      if (elementIsInScreen) {
       revealElements[i].classList.add("revealed");
       } else {
          revealElements[i].classList.remove("revealed");
           }
        }
       };
      
       window.addEventListener("scroll", scrollReveal);
          scrollReveal(); // Initial check
      
          return () => {
            window.removeEventListener("scroll", scrollReveal);
          };
        }, []);

  useEffect(() => {
    const alreadyTracked = sessionStorage.getItem("visitorTracked");
    if (!alreadyTracked) {
      dispatch(trackVisitor());
      sessionStorage.setItem("visitorTracked", "true");
    }
  }, [dispatch]);

const handleCRM = () => {
  navigate("/crm");
};

  return (
    <>
    <div className='home__wrapper' ref={servicesRef}>
      <h1 className="sr-only">
  Digital Marketing & Web Development Agency in Kenya
</h1>

      <Nav/>
     <section className="hero-section" >
       <div className='hero__left-col-1'>
        
       <div className="top-col" data-reveal="left">
     <p>Top - Tier ///////</p>
     
  </div>
       
        <div className="  hero__content-1" >
        <h2 data-reveal="left">
          Grow <span className="highlight">Your Business </span>{isDesktop && ( <br />)}
          With <span className="highlight">Smart Solutions</span>.
        </h2>

        <div className='left__content-1'  >
      <p data-reveal="left">
        From branding and marketing to web development, 
        we merge creativity with technology to create solutions that move your business forward.
      </p>

       
        </div>

        <div className="hero-buttons">
          <button data-reveal="left" className="btn btn-primary" onClick={handleLearnMore}>Learn more</button>
         <a href='/get-in-touch'>
          <button data-reveal="right" className="btn btn-secondary">Let’s Talk →</button>

         </a>
        </div>
      </div>
       </div>

      
      <div className='hero__right-col-1'>
          <div className="serial-code" data-reveal="right">
    <span>XR-1784-ROARZ</span>
  </div>
      <div className="  hero_img-1" data-reveal="right">
         
    <img
      loading="lazy"
      src={heroImage}
      alt="App Screen 1"
      className={`phone phone-front ${loaded ? "loaded" : "loading"}`}
      onLoad={() => setLoaded(true)}
    />
         </div>
      </div>


    </section>  
      
 <section className="about-section" >
  <h2 className="about-heading" data-reveal>We're a full-service marketing agency.</h2>
  
  <div className="service-tags" data-reveal>
    <span onClick={handleDigitalMarketing}><IoIosFlash className='tag-icon'/> Digital Marketing</span>
    <span onClick={handleWebsite}><TfiWorld className='tag-icon'/> Websites</span>
    <span onClick={handleInvoice}><FaFileInvoiceDollar className='tag-icon'/> Invoice Generator</span>
    <span onClick={handleCRM}><MdOutlineSupportAgent className='tag-icon'/> CRM Solutions</span>
     {/*   
      <span onClick={handleVideo}><RiVideoFill className='tag-icon'/> Video</span>
  */}
  </div>

  <section className="services-cards-wrapper">

<div className="card-container" data-reveal onClick={handleDigitalMarketing}>
<div className="card-content">
   <div className='card-content__1'>
  <h3 className="card-title" data-reveal>Digital Marketing</h3>
  {isDesktop ?  (
  <p className="card-subtitle" data-reveal>
    Tailored digital marketing strategies designed to help your brand stand out and connect 
    with the right audience. From social media campaigns to SEO and paid ads, the focus is on 
    visibility, engagement, and measurable results that move your business forward.
  </p>
  ): (
  <p className="card-subtitle" data-reveal>
    Tailored digital marketing strategies designed to help your brand stand out and connect 
    with the right audience.   </p>    
  )}

   </div>

 {isDesktop && (
  <div className="card-tags" >
    <span>Content & Creative</span>
    <span>Paid Media & Performance</span>
    <span>Analytics & Insights</span>
  </div>
 )}

    {!isDesktop && (
      <div className='learn__more-btn'>
      <a href='/digital-marketing' className=' card__button-1'>
   Explore

      </a>
      </div>
  )}

</div>


  <div className="card-image">
        <img
      loading="lazy"
      src={caseStudyImg}
      alt="Digital Marketing"
      title="Digital Marketing"
      className= {loaded ? "loaded" : "loading"}
      onLoad={() => setLoaded(true)}
    />
      <button className="card-button">Explore</button>
  </div>
</div>


    <div onClick={handleWebsite} data-reveal className=" card-container">
<div className="card-content">
  <div className='card-content__1'>
  <h3 className="card-title" data-reveal>Website Design & {!isDesktop && <br></br>} Development</h3>
  {isDesktop ? (
  <p className="card-subtitle" data-reveal>
    Modern, responsive websites that don’t just look good, but also work seamlessly across all devices. 
    From e-commerce stores to corporate sites, the focus is on speed, user experience, and conversions, 
    ensuring your online presence truly reflects the strength of your business.
  </p>
  ) : (
  <p className="card-subtitle" data-reveal>
    Modern, responsive websites that don’t just look good, but also work seamlessly across all devices. 
   </p>
  )}

  </div>

{isDesktop && (
  <div className="card-tags" >
    <span>Website Design</span>
    <span>Website Development</span>
    <span>Online Stores</span>
  </div>
)

}
  
    {!isDesktop && (
      <div className='learn__more-btn'>
      <a href='/website' className=' card__button-1'>
     Explore
      </a>
      </div>
  )}

</div>


  <div className="card-image"  >
     <img
      loading="lazy"
      src={caseStudy2}
      alt="Website Development"
      title="Website Development"
      className= {loaded ? "loaded" : "loading"}
      onLoad={() => setLoaded(true)}
    />    
      <button className="card-button">Explore</button>
  </div>
</div>



  <div className="card-container" data-reveal onClick={handleInvoice}>
  <div className="card-content">
  <div className='card-content__1'>
    <h3 className="card-title" data-reveal>Invoice Generator</h3>
   {isDesktop ? (
  <p className="card-subtitle" data-reveal>
    An efficient way to create, send, and manage invoices with ease. The Invoice Generator 
    simplifies billing, saves time, and ensures accuracy, whether you’re handling one client 
    or managing hundreds. Designed for businesses that value professionalism and speed.
  </p> 
   ) : (
  <p className="card-subtitle" data-reveal>
    An efficient way to create, send, and manage invoices with ease.    </p> 
   )}  
   
    </div>  
 
  {isDesktop && (
  <div className="card-tags" >
    <span>Create Invoice</span>
    <span>Send Invoices</span>
     
    <span> Tracking & Management</span>
  </div> 
  )}

    {!isDesktop && (
      <div className='learn__more-btn'>
      <a href='/invoice-generator' className=' card__button-1'>
     Explore
      </a>
      </div>
  )}

   </div>

  <div className="card-image">
     <img
      loading="lazy"
      src={caseStudy3}
      title="Invoice Generator"
      alt="Invoice Generator"
      className= {loaded ? "loaded" : "loading"}
      onLoad={() => setLoaded(true)}
    />    
      <a href='/invoice-generator' className="card-button">Explore</a>
  </div>
</div>
 
<div className="card-container" data-reveal onClick={handleCRM}>
  <div className="card-content">
    <div className='card-content__1'>
      <h3 className="card-title" data-reveal>CRM Solutions</h3>

      {isDesktop ? (
        <p className="card-subtitle" data-reveal>
          Smart CRM solutions built to help businesses manage leads, customer conversations,
          follow-ups, and sales pipelines more efficiently. Designed to improve customer
          relationships, team productivity, and business growth through better organization
          and automation.
        </p>
      ) : (
        <p className="card-subtitle" data-reveal>
          Smart CRM solutions to help manage leads, customers, and follow-ups with ease.
        </p>
      )}
    </div>

    {isDesktop && (
      <div className="card-tags">
        <span>Lead Management</span>
        <span>Sales Tracking</span>
        <span>Customer Support</span>
      </div>
    )}

    {!isDesktop && (
      <div className='learn__more-btn'>
        <a href='/crm' className='card__button-1'>
          Explore
        </a>
      </div>
    )}
  </div>

  <div className="card-image">
    <img
      loading="lazy"
      src={caseStudy5}
      alt="CRM Solutions"
      title="CRM Solutions"
      className={loaded ? "loaded" : "loading"}
      onLoad={() => setLoaded(true)}
    />
    <button className="card-button">Explore</button>
  </div>
</div>

 {/*
     <div className=" card-container" data-reveal onClick={handleVideo}>
  <div className="card-content">
  <div className='card-content__1'>
    <h3 className="card-title" data-reveal>Video</h3>
   {isDesktop ? (
<p className="card-subtitle" data-reveal>
  Video has the power to capture attention and tell stories like nothing else. Our video 
  solutions bring your brand to life through creative storytelling, high-quality production, 
  and strategic editing — designed to engage, inspire, and drive results across every platform.
</p>
   ) : (
<p className="card-subtitle" data-reveal>
  Video has the power to capture attention and tell stories like nothing else. </p>
   )} 

  </div>

 {isDesktop && (
  <div className="card-tags">

  <span>Promotional Videos</span>
  <span>Editing & Post-Production</span>
  <span>Social Media Content</span>
</div>
 )}

    {!isDesktop && (
      <div className='learn__more-btn'>
      <a href='https://lozano-films.onrender.com' className=' card__button-1'>
     Learn more
      </a>
      </div>
  )}

   
   </div>

  <div className="card-image">
  <video autoPlay muted loop playsInline>
    <source src={projectVideo} type="video/mp4" />
  </video>
     <button className="card-button" onClick={handleVideo}>Learn more</button>
  </div>
</div>
 
 */}

 


 

  </section>


  
</section>


<section className="choose-us-section">

  <div className="overlay">
    <h3 data-reveal>What sets us apart?</h3>
    <p data-reveal>
      We believe three main pillars make us the go-to agency for our clients.
      Take a look at how our experience, our approach to growth, and our
      transparent process set us apart from the crowd.
    </p>

    <div className="counter" data-reveal>
      <div className="pillar">
        <span className="number">1</span>
        <p><strong>Proven</strong><br />Experience</p>
      </div>
      <div className="pillar">
        <span className="number">2</span>
        <p><strong>Local Roots,</strong><br />Global Reach</p>
      </div>
      <div className="pillar">
        <span className="number">3</span>
        <p><strong>Transparent</strong><br />Process</p>
      </div>
    </div>
  </div>
</section>

<section className="process-section">
  <div className="process-header">
    <h3 data-reveal>Our crystal-clear approach, every step of the way</h3>
    <p data-reveal>
      No surprises, no shortcuts. We follow six proven steps and keep you in the
      loop at every stage.
    </p>
  </div>

  <div className="process-counter">
    {[
      { step: "Discover", desc: "Understand your goals, audience, and map out obstacles" },
      { step: "Style", desc: "Define your project's creative direction" },
      { step: "Plan", desc: "Finalise roadmap for design and execution" },
      { step: "Create", desc: "Craft visuals that bring your ideas to life" },
      { step: "Assemble", desc: "Seamlessly package all assets for launch" },
      { step: "Launch", desc: "Share your project with the world" },
    ].map((item, idx) => (
      <div className="process-card" key={idx}>
        <div className="process-content" data-reveal>
        <div className="circle" >
          <span className="number">{idx + 1}</span>
          <span className="step">{item.step}</span>
        </div>
        <p >{item.desc}</p>

        </div>
 
      </div>
    ))}
  </div>
</section>



<section className="client-testimonials">
  <h3>
    What our clients have said <br />
    <span>about our work</span>
  </h3>

  <div className="testimonial-cards">
    {/* Carman Autos Ltd */}
    <div className="testimonial-card">
      <p className="quote">
        “Our dealership website is sleek, fast, and easy for customers to browse
        cars. We’ve seen more online inquiries and even closed sales directly
        through the site.”
      </p>
      <div className="client-info">
        <img
          src={testimonial}
          alt="James Mwangi"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Jorum Ndung'u</p>
          <p className="client-title">Managing Director — Carman Autos Ltd</p>
        </div>
      </div>
    </div>

    {/* Qentrain Solutions */}
    <div className="testimonial-card">
      <p className="quote">
        “Our agribusiness website now acts as a hub for farmers and partners.
        The design is professional and the backend makes it easy for us to
        update market information and services.”
      </p>
      <div className="client-info">
        <img
          src={testimonial1}
          alt="Mercy Wanjiku"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Peter Kahenya  </p>
          <p className="client-title">Founder — Qentrain Solutions</p>
        </div>
      </div>
    </div>

    {/* Syntax by Collins */}
    <div className="testimonial-card">
      <p className="quote">
        “The website beautifully reflects our mission and heart for young people. It communicates purpose, growth, and hope with clarity and warmth."
       </p>
      <div className="client-info">
        <img
          src={testimonial2}
          alt="Collins Otieno"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Dorothy Wawira</p>
          <p className="client-title">Founder — Potters Love Network </p>
        </div>
      </div>
    </div>

    {/* Lozano Films */}
    <div className="testimonial-card">
      <p className="quote">
        “As a director, my website needed to feel cinematic and bold. They
        captured my vision perfectly, now my films and reels have a beautiful
        home online.”
      </p>
      <div className="client-info">
        <img
          src={testimonial3}
          alt="Brian Lozano"
          className="client-avatar"
        />
        <div>
          <p className="client-name">Brian Lozano</p>
          <p className="client-title">Film Director — Lozano Films</p>
        </div>
      </div>
    </div>
  </div>
</section>

<section className="booking-wrapper">
  <div className="booking-content">
    <h3 data-reveal>Let's get to work</h3>
    <p data-reveal>Ready to get started? Book a Discovery Call so we can learn more about your needs and discuss how we can help.</p>
    <button  className="get-started-btn" onClick={handleContactBtn}>
      Get Started <span className="plus-icon">+</span>
    </button>
  </div>
   
</section>

<Footer/>
 
    </div>

    </>

  );
};

export default Home;
